<template>
	<div>
		<div class="header-container">
			<a-breadcrumb class="breadcrumb">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<!-- <a-button icon="sync" @click="apiMemberQueryList">刷新</a-button> -->
				<a-button class="qinang-button-margin" icon="edit" @click="handleEdit" :disabled="!tableSelectedRow">会员信息</a-button>
			</div>
		</div>
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="会员查询">
				<div class="query-container">
					<div class="query-item">
						<div style="width: 120px;">所属服务商：</div>
						<a-select v-model="query.facilitatorId" style="width: 100%;" @change="handleFacilitatorChange">
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div class="query-item query-item-end">
						<a-button type="primary" icon="search" @click="apiMemberQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table 
				:columns="tableColumns" 
				:data-source="tableData" 
				row-key="cardInfoId" 
				:row-selection="rowSelection"
				:pagination="false" 
				:loading="tableLoading">
			</a-table>
			
			<a-pagination 
				style="text-align: right;margin: 10px;" 
				:current="query.page" 
				:total="query.total" 
				:default-page-size="query.size" 
				show-size-changer 
				show-quick-jumper 
				size="small" 
				:page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" 
				@change="pageChange" 
				@showSizeChange="showSizeChange"/>
			
		</div>
		<a-modal 
			class="qa-modal" 
			title="会员信息"
			:visible="editVisible"
			@cancel="handleEditCancel"
			:maskClosable="false"
			:keyboard="false">
			<div class="modal-content">
				<a-form-model 
					class="form-template-form"
					:model="editForm" 
					labelAlign="left"
					:label-col="{span: 6}" 
					:wrapper-col="{span: 16}">
					<a-form-model-item 
						v-for="field in columnConfig" 
						:key="field.fieldName"
						:label="field.displayContent || field.fieldName">
						<template v-if="field.type === 'radio'">
							<a-radio-group v-model="editForm[field.fieldName]">
								<a-radio 
									v-for="opt in parseOptions(field.dataSet)" 
									:key="opt.value" 
									:value="opt.value">
									{{opt.label}}
								</a-radio>
							</a-radio-group>
						</template>
						<template v-else-if="field.type === 'checkbox'">
							<a-checkbox-group v-model="editForm[field.fieldName]" :options="parseOptions(field.dataSet)" />
						</template>
						<template v-else-if="field.type === 'select'">
							<a-select v-model="editForm[field.fieldName]" allow-clear :placeholder="`请选择${field.displayContent}`">
								<a-select-option 
									v-for="opt in parseOptions(field.dataSet)" 
									:key="opt.value" 
									:value="opt.value">
									{{opt.label}}
								</a-select-option>
							</a-select>
						</template>
						<template v-else-if="field.type === 'textarea'">
							<a-textarea v-model="editForm[field.fieldName]" :rows="3" :placeholder="`请输入${field.displayContent}`" />
						</template>
						<template v-else-if="field.type === 'date'">
							<a-date-picker 
								style="width: 100%;" 
								v-model="editForm[field.fieldName]" 
								:value-format="'YYYY-MM-DD'"
								:placeholder="`请选择${field.displayContent}`" />
						</template>
						<template v-else>
							<a-input v-model="editForm[field.fieldName]" :placeholder="`请输入${field.displayContent}`" />
						</template>
					</a-form-model-item>
				</a-form-model>
			</div>
			<template slot="footer">
				<div class="modal-footer">
					<a-button @click="handleEditCancel">取消</a-button>
					<a-button type="primary" @click="handleEditSubmit" :loading="saveLoading">保存</a-button>
				</div>
			</template>
		</a-modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu') || '会员管理',
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu') || '会员列表',
				tableLoading: false,
				tableData: [],
				tableColumns: [],
				columnConfig: [], // 保存表头配置信息，用于数据渲染
				facilitatorList: [],
				tableSelectedRow: null,
				editVisible: false,
				editForm: {},
				saveLoading: false,
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: '',
				}
			};
		},
		methods: {
			// 获取表头配置
			async apiMemberColumns() {
				try {
					const { data: res } = await this.$http.post(this.navigation.apiMemberColumns, {facilitatorId: this.query.facilitatorId});
					if (res.code == 200) {
						// 保存原始配置信息
						this.columnConfig = res.data || [];
						
						// 定义固定列
						const fixedColumns = [
							{
								title: 'ID',
								dataIndex: 'cardInfoId',
								key: 'cardInfoId',
								align: 'center',
								width: 100,
								fixed: 'left'
							},
							{
								title: '创建时间',
								dataIndex: 'createTime',
								key: 'createTime',
								align: 'center',
								width: 180
							}
						];
						
						// 将接口返回的表头配置转换为 Ant Design Table 需要的格式
						const dynamicColumns = this.columnConfig.map((col, index) => {
							const column = {
								title: col.displayContent || col.fieldName,
								dataIndex: col.fieldName,
								key: col.fieldName || `col_${index}`,
								align: 'center',
								width: col.width
							};
							
							// 如果是radio、checkbox或select类型，使用自定义渲染函数
							if (col.type === 'radio' || col.type === 'checkbox' || col.type === 'select') {
								column.customRender = (text, record, index) => {
									return this.getDisplayText(text, col.dataSet);
								};
							}
							
							return column;
						});
						
						// 合并固定列和动态列
						this.tableColumns = [...fixedColumns, ...dynamicColumns];
					} else {
						this.$message.error(res.msg || '获取表头配置失败');
					}
				} catch (error) {
					console.error('获取表头配置失败:', error);
					this.$message.error('获取表头配置失败，请稍后重试');
				}
			},
			
			// 根据数据集获取显示文本（用于radio、checkbox、select类型）
			getDisplayText(value, dataSet) {
				if (value === undefined || value === null || value === '') {
					return '-';
				}
				if (!dataSet || dataSet === '[]' || dataSet === '') {
					return Array.isArray(value) ? value.join('、') : value;
				}
				const options = this.parseOptions(dataSet);
				const map = {};
				options.forEach(opt => {
					map[opt.value] = opt.label;
				});
				if (Array.isArray(value)) {
					return value.map(val => map[val] || val).join('、');
				}
				return map[value] || value;
			},
			
			// 查询会员列表
			async apiMemberQueryList() {
				this.tableLoading = true;
				try {
					const { data: res } = await this.$http.post(this.navigation.apiMemberQueryList, this.query);
					if (res.code == 200) {
						const list = res.data.list || [];
						this.tableData = list.map(item => {
							const record = { ...item };
							if (record.touristJson && record.touristJson !== '[]') {
								try {
									const fields = typeof record.touristJson === 'string' ? JSON.parse(record.touristJson) : record.touristJson;
									if (Array.isArray(fields)) {
										// 数组格式 [{fieldName, value}, ...]
										fields.forEach(field => {
											if (field && field.fieldName) {
												record[field.fieldName] = field.value || '';
											}
										});
									} else if (fields && typeof fields === 'object') {
										// 对象格式 { name: '张三', sex: 1 }
										Object.keys(fields).forEach(key => {
											record[key] = fields[key];
										});
									}
								} catch (e) {
									console.warn('解析会员动态字段失败:', e, record.touristJson);
								}
							}
							return record;
						});
						if (this.tableSelectedRow) {
							const exists = this.tableData.find(row => row.cardInfoId === this.tableSelectedRow.cardInfoId);
							if (!exists) {
								this.tableSelectedRow = null;
							}
						}
						this.query.page = res.data.pages?.page || this.query.page;
						this.query.size = res.data.pages?.size || this.query.size;
						this.query.total = res.data.pages?.total || 0;
						this.tableLoading = false;
					} else {
						this.$message.error(res.msg || '查询失败');
						this.tableLoading = false;
					}
				} catch (error) {
					console.error('查询失败:', error);
					this.$message.error('查询失败，请稍后重试');
					this.tableLoading = false;
				}
			},
			// 解析数据集选项
			parseOptions(dataSet) {
				if (!dataSet || dataSet === '[]' || dataSet === '') {
					return [];
				}
				let options = [];
				try {
					const parsed = typeof dataSet === 'string' && (dataSet.trim().startsWith('[') || dataSet.trim().startsWith('{'))
						? JSON.parse(dataSet)
						: null;
					if (Array.isArray(parsed)) {
						options = parsed.map(item => ({
							label: item.label ?? item.displayContent ?? item.name ?? item.value ?? '',
							value: item.value ?? item.key ?? item.fieldName ?? item.label ?? ''
						}));
					} else if (parsed && typeof parsed === 'object') {
						options = Object.keys(parsed).map(key => ({ label: parsed[key], value: key }));
					} else {
						options = dataSet.split(',').filter(Boolean).map(item => {
							const [label, value] = item.split('=');
							return { label: label || value, value: value ?? label };
						});
					}
				} catch (err) {
					options = dataSet.split(',').filter(Boolean).map(item => {
						const [label, value] = item.split('=');
						return { label: label || value, value: value ?? label };
					});
				}
				return options;
			},
			// 点击编辑
			handleEdit() {
				if (!this.tableSelectedRow) {
					this.$message.warning('请选择要编辑的会员');
					return;
				}
				const formData = {};
				this.columnConfig.forEach(field => {
					let value = this.tableSelectedRow[field.fieldName];
					if (field.type === 'checkbox') {
						if (typeof value === 'string' && value) {
							try {
								value = JSON.parse(value);
							} catch (e) {
								value = value.split(',');
							}
						}
						if (!Array.isArray(value)) {
							value = value ? [value] : [];
						}
					}
					formData[field.fieldName] = value ?? '';
				});
				this.editForm = formData;
				this.editVisible = true;
			},
			// 取消编辑
			handleEditCancel() {
				this.editVisible = false;
				this.editForm = {};
			},
			// 提交编辑
			async handleEditSubmit() {
				if (!this.tableSelectedRow) {
					this.$message.warning('请选择要编辑的会员');
					return;
				}
				const facilitatorId = this.tableSelectedRow.facilitatorId || this.query.facilitatorId;
				if (!facilitatorId) {
					this.$message.warning('请选择所属服务商');
				 return;
				}
				const payload = {
					cardInfoId: this.tableSelectedRow.cardInfoId,
					facilitatorId,
					touristJson: JSON.stringify(this.editForm || {})
				};
				this.saveLoading = true;
				try {
					const { data: res } = await this.$http.post(this.navigation.apiMemberEdit, payload);
					if (res.code === 200) {
						this.$message.success(res.msg || '保存成功');
						this.editVisible = false;
						this.editForm = {};
						this.apiMemberQueryList();
					} else {
						this.$message.error(res.msg || '保存失败');
					}
				} catch (error) {
					console.error('保存失败:', error);
					this.$message.error('保存失败，请稍后重试');
				} finally {
					this.saveLoading = false;
				}
			},
			
			// 分页改变
			pageChange(page, pageSize) {
				this.query.page = page;
				this.query.size = pageSize;
				this.apiMemberQueryList();
			},
			
			// 每页条数改变
			showSizeChange(current, size) {
				this.query.page = current;
				this.query.size = size;
				this.apiMemberQueryList();
			},
			
			// 服务商选择改变
			handleFacilitatorChange() {
				// 重新获取表头配置并查询数据
				this.apiMemberColumns().then(() => {
					this.query.page = 1; // 重置到第一页
					this.apiMemberQueryList();
				});
			},
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data || [];
					if (!this.query.facilitatorId && this.facilitatorList.length) {
						this.query.facilitatorId = this.facilitatorList[0].facilitatorId;
						// 先获取表头配置，再查询数据
						this.apiMemberColumns().then(() => {
							this.apiMemberQueryList();
						});
					}
				} else {
					this.$message.error(res.msg);
				}
			},
		},
		computed: {
			rowSelection() {
				return {
					type: 'radio',
					selectedRowKeys: this.tableSelectedRow ? [this.tableSelectedRow.cardInfoId] : [],
					onChange: (selectedRowKeys, selectedRows) => {
						this.tableSelectedRow = selectedRows[0] || null;
					}
				};
			}
		},
		created() {
            this.apiFacilitatorList();
		}
	};
</script>

<style scoped>
	/* 头部容器 */
	.header-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.breadcrumb {
		margin: 16px 0;
	}

	/* 查询区域 */
	.query-container {
		display: flex;
		justify-content: space-between;
	}

	.query-item {
		width: 30%;
		display: flex;
		align-items: center;
	}

	.query-item-end {
		justify-content: flex-end;
	}

	.query-label {
		width: 120px;
	}

	.query-input {
		width: 100%;
	}



	.qinang-button-margin {
		margin-left: 8px;
	}

	/* 空数据提示 */
	.empty-tip {
		text-align: center;
		padding: 40px;
		color: #999;
	}

	/* 弹窗样式 */
	.qa-modal ::v-deep .ant-modal {
		width: auto !important;
		max-width: 50vw;
	}

	.qa-modal ::v-deep .ant-modal-content {
		background-color: #fff;
		width: auto;
	}

	.qa-modal ::v-deep .ant-modal-body {
		max-height: calc(100vh - 110px);
		overflow-y: auto;
		padding: 24px;
		width: auto;
		position: relative;
	}

	.modal-content {
		background-color: #fff;
		overflow: visible;
		min-width: 600px;
		max-width: 1000px;
		position: relative;
		height: calc(100vh - 160px);
	}

	.form-template-form {
		width: 100%;
		overflow: visible;
		min-width: 600px;
	}

	.form-template-form ::v-deep .ant-form-item-control-wrapper {
		width: 100%;
	}
</style>

